<template>
  <div class="schoolCardList-container">
    <div v-if="!dialogVisibleTransaction && !dialogVisibleWarrantyConfig" class="schoolCardList-main flex">
      <main-left only-school @treeNodeClick="treeNodeClick" />
      <div class="schoolCardList-right div-layout">
        <module-title title="">
          <div class="right">
            <el-button
              v-show="treeNode.code"
              type="primary"
              size="medium"
              @click="singleAdd"
            >
              单个添加
            </el-button>
            <el-button
              v-show="treeNode.code"
              type="primary"
              size="medium"
              @click="initUploadData"
            >
              批量导入
            </el-button>
            <el-button
              v-show="treeNode.code"
              type="primary"
              size="medium"
              @click="handlerDownSchoolCard"
            >
              批量导出
            </el-button>
            <el-button
              v-show="treeNode.code"
              type="primary"
              size="medium"
              @click="handleIsConfig"
            >
              保修期配置
            </el-button>
            <el-button
              v-show="treeNode.code"
              type="primary"
              size="medium"
              @click="goTransaction"
            >
              异动记录
            </el-button>
            <el-tooltip placement="bottom" effect="light">
              <div slot="content">
                异动记录，分为三种情况: <br>
                1.异常绑定，是指绑定时用户选择的学校和核销表中该设备对应的学校不一致，需将该设备从核销表中删除。<br>
                2解绑后，当前设备将从核销表中删除。<br>
                3.变更设备后，核销表中原设备将被新设备替换，且原设备将从核销表中删除。<br>
              </div>
              <i class="el-icon-question tips-icon" />
            </el-tooltip>
          </div>
        </module-title>
        <div class="schoolCardList-right-contain">
          <p>{{ treeNode.name }}</p>
          <el-form
            ref="schoolCardSearchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
          >
            <el-form-item label="关联社区：" prop="communityId">
              <el-select v-model="searchForm.communityId" multiple placeholder="请选择" style="width:180px">
                <el-option
                  v-for="item in commandList"
                  :key="item.id"
                  :label="item.communityName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="核销类别：" prop="provType">
              <el-select v-model="searchForm.provType" placeholder="请选择" style="width:180px">
                <el-option value label="全部" />
                <el-option :value="1" label="自动核销" />
                <el-option :value="2" label="手动核销" />
              </el-select>
            </el-form-item>
            <el-form-item label="核销批次：" prop="deviceNo">
              <el-tooltip placement="bottom" effect="light">
                <div slot="content">
                  核销批次包括:<br>
                  1.每个通过设备发放助手App发放设6备的自然天为一个批次;<br>
                  2.每个通过运营管理平台单个添加或批量导入设备的自然天为一个批次。<br>
                </div>
                <i class="el-icon-question tips-icon" />
              </el-tooltip>
              <el-select v-model="searchForm.provDates" multiple placeholder="请选择" style="width:180px">
                <el-option
                  v-for="item in provDatesList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="绑定状态：" prop="bindFlag">
              <el-select
                v-model="searchForm.bindFlag"
                style="width:180px"
                placeholder="选择状态"
                name="bindFlag"
                size="medium"
                class="edit-form-input"
              >
                <el-option value label="全部" />
                <el-option :value="0" label="未绑定" />
                <el-option :value="1" label="已绑定" />
              </el-select>
            </el-form-item>
            <el-form-item label="学生卡IMEI号：" prop="imei">
              <el-input
                v-model="searchForm.imei"
                style="width:180px"
                name="imei"
                maxlength="15"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                class="edit-form-input"
                clearable
              />
            </el-form-item>
            <el-form-item style="margin-left:10px;">
              <el-button
                type="primary"
                size="medium"
                @click="fetchSchoolCardLisReset"
              >
                重置
              </el-button>
            </el-form-item>
            <el-form-item style="margin-left:10px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="fetchSearchFile"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <multiple-box :visible="isSelection" :selection-num="selectionNum">
            <span class="handle-span" @click="handleDdelete('more',$event)">批量删除</span>
          </multiple-box>
          <el-table
            v-loading="listLoading"
            :cell-class-name="cellcb"
            :data="schoolCardList"
            fit
            element-loading-text="Loading"
            class="list-table"
            highlight-current-row
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center" :selectable="selectable" />
            <el-table-column type="index" label="序号" align="center" />
            <el-table-column label="设备编号" width="120px" prop="deviceNo" align="center">
              <template slot-scope="scope">
                {{ scope.row.deviceNo?scope.row.deviceNo:'--' }}
              </template>
            </el-table-column>
            <el-table-column label="关联社区-只有精美社区的学校才有关联的社区，普通学校没有关联的社区" :render-header="renderHeader" width="120px" prop="communityName" align="center">
              <template slot-scope="scope">
                {{ scope.row.communityName?scope.row.communityName:'--' }}
              </template>
            </el-table-column>
            <el-table-column label="学生卡型号" prop="schoolCardModeName" width="130px" align="center" />
            <el-table-column label="学生卡IMEI号" prop="imei" align="center" width="150px" />
            <el-table-column label="核销日期-通过设备发放助手App扫码发放设备的日期或在运营管理平台批量导入设备的日期" :render-header="renderHeader" align="center" width="120px">
              <template slot-scope="scope">
                {{ scope.row.provDate }}
                <i class="el-icon-edit update-icon hide_input">
                  <el-date-picker
                    v-model="dateValue"
                    type="date"
                    value-format="yyyy-MM-dd"
                    @change="dateChenge($event,scope.row)"
                  />
                </i>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="provType" width="120px">
              <template slot="header">
                核销类别
                <el-tooltip effect="light" placement="bottom">
                  <div slot="content">
                    分为自动核销和手动核销<br>自动核销：通过设备发放助手App发放后自动完成核销；<br> 手动核销：通过运营管理平台单个添加或批量导入设备完成核销。
                  </div>
                  <i class="el-icon-question" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.provType===2?'手动核销':'自动核销' }}
              </template>
            </el-table-column>
            <el-table-column label="绑定状态" prop="bindFlag" align="center">
              <template slot-scope="scope">
                {{ scope.row.bindFlag ? '已绑定' : '未绑定' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="210px">
              <template slot-scope="scope">
                <div style="text-align:left">
                  <el-button
                    v-if="scope.row.bindFlag"
                    type="success"
                    size="small"
                    icon="el-icon-question"
                    @click="openStudentCardDetail(scope.row)"
                  >
                    详情
                  </el-button>
                  <el-button
                    v-if="scope.row.bindFlag"
                    type="primary"
                    size="small"
                    @click="changeDevice(scope.row)"
                  >
                    更换设备
                  </el-button>
                  <el-button
                    v-if="!scope.row.bindFlag"
                    type="primary"
                    size="small"
                    @click="handleDdelete('one',scope.row)"
                  >
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageSchoolCardList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 单个添加 -->
    <el-dialog
      v-if="dialogAddVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogAddVisible"
      title="添加"
      width="500px"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        :inline="true"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="请选择关联社区：" prop="communityId">
          <el-select v-model="addForm.communityId" placeholder="请选择">
            <el-option
              v-for="item in commandList"
              :key="item.id"
              :label="item.communityName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学生卡型号：" prop="schoolCardModelCode">
          <el-select v-model="addForm.schoolCardModelCode" placeholder="请选择学生卡类型">
            <el-option
              v-for="item in modelTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学生卡IMEI号：" prop="imei">
          <el-input
            v-model="addForm.imei"
            name="imei"
            auto-complete="off"
            size="medium"
            maxlength="15"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="核销日期：" prop="provDate">
          <el-date-picker
            v-model="addForm.provDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogAddVisible=false">
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="handleAddFrom"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 学生卡详情 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogViewVisible"
      title="学生卡详情"
      width="700px"
    >
      <p class="archivesTitle">
        基础信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>设备ID：</label>
            {{ handleCurrentCard.deviceNo||'--' }}
          </li>
          <li>
            <label for>所属学校：</label>
            {{ handleCurrentCard.schoolName||'--' }}
          </li>
          <li>
            <label for>学生卡IMEI号：</label>
            {{ handleCurrentCard.imei||'--' }}
          </li>
          <li>
            <label for>核销类别：
              <el-tooltip effect="light" placement="bottom">
                <div slot="content">分为自动核销和手动核销<br>自动核销：通过设备发放助手App发放后自动完成核销；<br> 手动核销：通过运营管理平台单个添加或批量导入设备完成核销。</div>
                <i class="el-icon-question" />
              </el-tooltip>
            </label>
            <!-- 1: 自动核销  2：手动核销 -->
            {{ handleCurrentCard.provType===1?'自动核销':'手动核销'||'--' }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>设备类型：</label>
            {{ handleCurrentCard.type||'--' }}
          </li>
          <li>
            <label for>关联社区：</label>
            {{ handleCurrentCard.communityName||'--' }}
          </li>
          <li>
            <label for>核销日期：
              <el-tooltip effect="light" placement="bottom">
                <div slot="content">通过设备发放助手App扫码发放设备的日期或在运营管理平台批量导入设备的日期</div>
                <i class="el-icon-question" />
              </el-tooltip>
            </label>
            {{ handleCurrentCard.provDate||'--' }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="archivesTitle">
        参数信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>设备型号：</label>
            {{ handleCurrentCard.schoolCardModeName||'--' }}
          </li>
          <li>
            <label for>嵌入式软件版本号：</label>
            {{ handleCurrentCard.scmVersion||'--' }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>系统版本号：</label>
            {{ handleCurrentCard.sysVersion||'--' }}
          </li>
          <li>
            <label for>桌面程序版本：</label>
            {{ handleCurrentCard.appVersion||'--' }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="archivesTitle">
        SIM卡绑定信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>学生卡SIM卡号：</label>
            {{ handleCurrentCard.sim||'--' }}
          </li>
        </ul><ul>
          <li>
            <label for>学生卡ICCID：</label>
            {{ handleCurrentCard.iccid||'--' }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="archivesTitle">
        绑定信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>学生姓名：</label>
            {{ handleCurrentCard.stuName||'--' }}
          </li>
          <li>
            <label for>所在班级：</label>
            {{ handleCurrentCard.className||'--' }}
          </li>
          <li>
            <label for>首次绑定时间：</label>
            {{ handleCurrentCard.bindTime||'--' }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>所在年级：</label>
            {{ handleCurrentCard.gradeName||'--' }}
          </li>
          <li>
            <label for>学生学号：</label>
            {{ handleCurrentCard.studentId||'--' }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="archivesTitle">
        保修信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>保修开始日期：</label>
            {{ handleCurrentCard.warrantyStartDate||'--' }}
          </li>
          <li>
            <!-- 1 ： 保修期内  0 ：保修期外 -->
            <label for>保修状态：</label>
            {{ handleCurrentCard.warrantyStatus===1?'保修期内':'保修期外'||'--' }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>保修期：</label>
            {{ handleCurrentCard.warrantyDay+'天'||'--' }}
          </li>
          <li>
            <label for>保修截止日期：</label>
            {{ handleCurrentCard.warrantyEndDate||'--' }}
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="dialogViewVisible = false">
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 更换设备 -->
    <el-dialog
      v-if="dialogReplaceVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogReplaceVisible"
      title="更换设备"
      width="500px"
    >
      <el-form
        ref="replaceForm"
        v-loading="replaceloading"
        :model="replaceForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="原IMEI号：" prop="imeiOld">
          <span>{{ replaceForm.imeiOld }}</span>
        </el-form-item>
        <el-form-item label="新IMEI号：" prop="imei">
          <el-input
            v-model="replaceForm.imei"
            name="imei"
            auto-complete="off"
            size="medium"
            placeholder="请输入"
            class="replace-form-input"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogReplaceVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handleReplaceSchoolCard">
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogUploadVisiblePackage"
      :close-on-click-modal="false"
      :visible.sync="dialogUploadVisiblePackage"
      title="批量导入"
      width="540px"
    >
      <el-form
        label-position="right"
        label-width="120px"
      >
        <div class="textCenter">
          <el-button type="primary" style=" margin-bottom: 20px" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">
            下载模板
          </el-button>
          <el-upload
            ref="upload"
            :on-success="onSuccess"
            :action="uploadUrl"
            :headers="uploadHeader"
            :on-progress="onProgress"
            :on-error="onError"
            :multiple="false"
            :limit="1"
            name="file"
            accept=".xls, .xlsx"
            class="handle-btn"
          >
            <el-button
              :loading="fileUploading"
              size="medium"
              type="primary"
              icon="el-icon-upload2"
            >
              {{ fileUploading?'上传文件中...':'上传文件' }}
            </el-button>
          </el-upload>
        </div>
      </el-form>
    </el-dialog>
    <Transaction
      v-if="dialogVisibleTransaction"
      :visible.sync="dialogVisibleTransaction"
    />
    <WarrantyConfig
      v-if="dialogVisibleWarrantyConfig"
      :visible.sync="dialogVisibleWarrantyConfig"
    />
    <!-- 批量导入异常 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogMultipleImportVisible"
      title="异常数据"
    >
      <p style="padding:0 0 20px 20px;">
        导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传
      </p>
      <el-scrollbar wrap-class="abnormal-table">
        <el-table
          :data="abnormalDataList"
          fit
          highlight-current-row
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="异常原因" prop="errorMsg" align="center">
            <template slot-scope="scope">
              <span style="color:red">{{ scope.row.errorMsg }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="downErrorInfo">下载异常信息</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import tableHeaderTip from '@/components/tableHeaderTip/tableHeaderTip';
import Transaction from './transaction';
import WarrantyConfig from './warrantyConfig';
import {
  replaceSchoolCard
} from '@/api/systemMaintenance/devicManage/schoolCardManage';
import {
  school_plate_repair_pagelist,
  school_plate_repair_add,
  provDatesList,
  schoolCommunityList,
  provDatesEdit,
  school_plate_repair_details,
  school_plate_repair_del,
  templateExcel,
  improtExcel,
  exportSimExcel
} from '@/api/systemMaintenance/devicManage/warrantyList';
import {
  modelTypeList
} from '@/api/systemMaintenance/devicManage/abnormalMonitoringManage';
import { getToken } from '@/utils/auth';
export default {
  name: 'WarrantyPeriodManage',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    tableHeaderTip,
    Transaction,
    WarrantyConfig
  },
  data() {
    var validateIemi = (rule, value, callback) => {
      const pattern2 = new RegExp(/^\d{15}$/);
      if (value !== '' && value !== null) {
        if (!(pattern2.test(value))) {
          callback(new Error('请输入数字字符'));
          return false;
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      dialogMultipleImportVisible: false,
      abnormalDataList: [],
      fileUploading: false, // 文件上传加载
      uploadUrl: '', // 上传文件URL
      uploadHeader: {
      }, // 上传文件上传头
      dateValue: '',
      treeNode: {}, // 机构树节点对象
      dialogVisibleWarrantyConfig: false,
      dialogVisibleTransaction: false,
      dialogAddVisible: false,
      dialogViewVisible: false, //  学生卡详情
      dialogReplaceVisible: false,
      dialogUploadVisiblePackage: false,
      handleCurrentCard: {}, // 当前点击学生
      searchForm: {
        bindFlag: '',
        communityId: '',
        imei: '',
        provDates: [],
        provType: '',
        schoolCode: '',
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      replaceForm: {
        imeiOld: '',
        imei: '',
        studentCode: ''
      },
      addForm: {
        imei: '',
        communityId: '',
        provDates: '',
        schoolCardModelCode: '',
        schoolCode: ''
      },
      addFormRules: {
        schoolCardModelCode: [
          { required: true, message: '学生卡型号不能为空', trigger: 'change' }
        ],
        imei: [
          { required: true, message: '学生卡IMEI号不能为空', trigger: 'change' },
          { trigger: 'blur', validator: validateIemi }
        ],
        provDate: [
          { required: true, message: '核销日期不能为空', trigger: 'change' }
        ]
      },
      commandList: [],
      provDatesList: [],
      commandListCopy: [],
      modelTypeList: [],
      replaceloading: false,
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选
      schoolCardList: [] //  学生卡列表
    };
  },
  computed: {
    // 是否为机构的普通管理员
    isOrdinaryOrgAdmin() {
      return (
        this.$store.getters.currentOrg.level !== 5 && !this.$store.getters.currentOrg.isSuperAdmin
      );
    },
    // 多选数量
    selectionNum() {
      return this.multipleSelection.length;
    },
    isSelection() {
      return this.multipleSelection.length > 0;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getTypeList();
      this.featchSchoolCommunityList();
      this.featchProvDatesList();
      this.fetchSchoolCardList();
    },
    // 初始化上传数据
    initUploadData() {
      this.dialogUploadVisiblePackage = true;
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadUrl = improtExcel(this.treeNode.code); // 导入
    },
    singleAdd() {
      this.dialogAddVisible = true;
      this.addForm = {
        imei: '',
        communityId: '',
        provDates: '',
        schoolCardModelCode: '',
        schoolCode: ''
      };
    },
    getTypeList() {
      modelTypeList().then(res => {
        this.modelTypeList = res.data;
      });
    },
    changeDevice(row) {
      this.replaceForm = {};
      this.dialogReplaceVisible = true;
      this.replaceForm.imeiOld = row.imei;
      this.replaceForm.studentCode = row.userCode;
    },
    featchSchoolCommunityList() {
      if (!this.treeNode.code) return;
      schoolCommunityList(this.treeNode.code).then(res => {
        this.commandList = res.data.list;
      });
    },
    featchProvDatesList() {
      if (!this.treeNode.code) return;
      provDatesList(this.treeNode.code).then(res => {
        this.provDatesList = res.data;
      });
    },
    handleIsConfig() {
      this.dialogVisibleWarrantyConfig = true;
    },
    goTransaction() {
      this.dialogVisibleTransaction = true;
    },
    renderHeader(h, { column }) {
      const title = column.label.split('-')[0];
      const msg = column.label.split('-')[1];
      return h( // 创建元素
        'div', [
          h('span', title), // label标题文案
          h(tableHeaderTip, { // tooltips组件
            props: {
              messages: [msg]
            }
          })
        ]
      );
    },
    cellcb({ row }) {
      if (row.bindFlag === 1) {
        return 'myCell';
      }
    },
    dateChenge(date, row) {
      const op = {
        provDate: date,
        id: row.id
      };
      provDatesEdit(op)
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: '更换成功',
            showClose: false,
            duration: 2000
          });
          this.replaceloading = false;
          this.dialogReplaceVisible = false;
          this.fetchSchoolCardList();
        })
        .catch(() => {
          this.replaceloading = false;
        });
    },
    handleDdelete(val, row) {
      let noticeIds = [];
      if (val === 'one') {
        noticeIds = row.id;
      } else if (val === 'more' && this.multipleSelection.length > 0) {
        noticeIds = this.multipleSelection.map(x => x.id).join(',');
      }
      this.$confirm(`确定要删除${this.multipleSelection.length > 0 ? '所选' : '该条'}学生卡保修期记录么?`, '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        school_plate_repair_del(noticeIds).then(res => {
          if (res.code === '0') {
            this.fetchSchoolCardList();
          }
        });
      }).catch(() => {});
    },
    handlerExcelTemplate() {
      window.location.href = templateExcel(1);
    },
    selectable(row, index) {
      if (row.bindFlag !== 1) {
        return true;
      } else {
        return false;
      }
    },

    // 导入 加载
    onProgress() {
      this.fileUploading = true;
    },
    onError() {},

    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.fetchSchoolCardList();
        this.dialogUploadVisiblePackage = false;
      } else {
        if (response.data) {
          this.dialogMultipleImportVisible = true;
          this.abnormalDataList = [];
          const list = response.data;
          list.forEach(v => {
            this.abnormalDataList.push({ errorMsg: v });
          });
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
          this.abnormalDataList = [];
        }
      }
    },
    // 树点击事件
    treeNodeClick(data) {
      this.treeNode = data;
      this.searchForm.schoolCode = this.treeNode.code;
      this.init();
    },
    // 分页
    pageSchoolCardList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchSchoolCardList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageSize = obj.limit;
      this.fetchSearchFile();
    },
    fetchSearchFile() {
      this.searchForm.pageNum = 1;
      this.fetchSchoolCardList();
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 更换设备
    handleReplaceSchoolCard() {
      this.$refs['replaceForm'].validate((valid) => {
        if (valid) {
          this.replaceloading = true;
          var op = {
            imei: this.replaceForm.imei,
            studentCode: this.replaceForm.studentCode
          };
          replaceSchoolCard(op).then((res) => {
            this.$notify.success({ title: 'Success', message: '更换成功', showClose: false, duration: 2000 });
            this.replaceloading = false;
            this.dialogReplaceVisible = false;
            this.fetchSchoolCardList();
          }).catch(() => {
            this.replaceloading = false;
          });
        }
      });
    },
    // 学生卡列表导出
    handlerDownSchoolCard() {
      const communityId = this.searchForm.communityId.toString();
      const provDates = this.searchForm.provDates.toString();
      var op = {
        ...this.searchForm,
        communityId,
        provDates,
        stype: 1
      };
      window.location.href = exportSimExcel(this.treeNode.code, op);
    },
    // 获取学生详情
    openStudentCardDetail(row) {
      school_plate_repair_details(row.id).then((res) => {
        if (res.data) this.handleCurrentCard = res.data;
      });
      this.dialogViewVisible = true;
    },
    fetchSchoolCardLisReset() {
      this.searchForm = {
        ...this.searchForm,
        bindFlag: '',
        communityId: '',
        imei: '',
        provDates: [],
        provType: '',
        schoolCode: this.treeNode.code,
        pageNum: 1
      };
      this.fetchSchoolCardList();
    },
    // 获取学生卡列表
    fetchSchoolCardList() {
      this.listLoading = true;
      const communityId = this.searchForm.communityId.toString();
      const provDates = this.searchForm.provDates.toString();
      var op = {
        ...this.searchForm,
        communityId,
        provDates,
        type: 2 // 1校牌 2学生卡
      };
      school_plate_repair_pagelist(op).then((res) => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.schoolCardList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.schoolCardList = [];
        }
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },
    // 单个添加
    handleAddFrom() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          var op = {
            imei: this.addForm.imei,
            schoolCode: this.treeNode.code,
            communityId: this.addForm.communityId,
            provDate: this.addForm.provDate,
            schoolCardModelCode: this.addForm.schoolCardModelCode,
            type: 2 // 1校牌 2学生卡
          };
          school_plate_repair_add(op).then((res) => {
            this.$notify.success({ title: 'Success', message: '添加成功', showClose: false, duration: 2000 });
            this.dialogAddVisible = false;
            this.fetchSchoolCardList();
          }).catch(() => {
          });
        }
      });
    }
  }
};
</script>
<style lang="scss">
.abnormal-table {
  height: 500px;
}
</style>
<style lang="scss" scoped>
.schoolCardList-container {
  .schoolCardList-main {
    min-height: 80vh;
    padding-bottom: 20px;
    .schoolCardList-right {
      overflow: hidden;
      .schoolCardList-right-contain {
        > p {
          padding-left: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          margin-bottom: 20px;
        }
      }
    }
  }
  .edit-form-input {
    width: 8vw;
  }
  .replace-form-input {
    width: 80%;
  }
  .marginleft-10 {
    margin-left: 10px;
  }
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
//隐藏的CSS代码
/*按钮日期选择器隐藏ipnut*/
.hide_input{
    position: relative !important;
}
.update-icon{
  cursor: pointer;
  color: rgb(62, 159, 238);
}
//修改控件自带的css
.hide_input .el-date-editor {
    position: absolute ;//绝对定位
    top: 0 ;
    left: 0 ;
    opacity: 0;//设置完全透明
}
 /deep/.myCell .el-checkbox__input {
  display: none;
}

</style>
